module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./icons.js"));
	}, "admission-icons");
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy&name=admission-icons!./src/pages/admission/icons.js
// module id = 88
// module chunks = 6